import { render } from "./Menu.vue?vue&type=template&id=50e8344c&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"

import "./Menu.vue?vue&type=style&index=0&id=50e8344c&scoped=true&lang=css"
import "./Menu.vue?vue&type=style&index=1&id=50e8344c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e8344c"]])

export default __exports__